import { i18n } from '@/plugins/i18n'

export const transactionTypes = {
    API: "zero",
    PARDAKHT_SHAKHSI: 1,
    // PAYMAN: 3,
    IVR: 5,
    ALLOTMENT: 8,
    ALLOTMENT_PAYMENT_HELPER: 19,
    ALLOTMENT_DEDICATED: 20,
    DEDICATED: 10,
    COLLECTIVE: 12,
    COLLECTIVE_DEDICATED: 14,
    COLLECTIVE_PAYMENT_HELPER: 16,
    SMS_WALLET_RECHARGE: 18,
    MONEY_REQUEST: 21,
    CARD_TO_CARD: 22,
    OUT_SOURCE: 23,
    WALLET_RECHARGE: 26,
    COLLECTIVE_PARDAKHT_SHAKHSI : 28,
    COLLECTIVE_MONEY_REQUEST  : 29,
    MONEY_REQUEST_BILL: 30,
    COLLECTIVE_ONLINE_FACTOR: 31,
    ONLINE_FACTOR: 32,
    IVR_WALLET_RECHARGE: 33,
    COLLECTIVE_TO_WALLET: 34,
    VIP: 35,
    VIP_WALLET_RECHARGE: 36,
    COLLECTIVE_TO_WALLET_MONEY_REQUEST: 37,
    COLLECTIVE_TO_WALLET_PARDAKHT_SHAKHSI: 38,
    COLLECTIVE_TO_WALLET_ONLINE_FACTOR: 39,
    MONEY_REQUEST_BILL_TO_WALLET: 40,
    ENAMAD_REGISTER: 41,
    OPEN_BANKING_WALLET_RECHARGE: 46,
    COLLECTION_ON_PAYMENT_HELPER_TO_WALLET : 47,
    COLLECTION_ON_PAYMENT_HELPER_TO_WALLET_MONEY_REQUEST : 48,
    COLLECTION_ON_PAYMENT_HELPER_TO_WALLET_PARDAKHT_SHAKHSI : 49,
    COLLECTION_ON_PAYMENT_HELPER_TO_WALLET_ONLINE_FACTOR : 50,
    DEPOSIT_WITH_ID : 51,
    PAYMENT_HELPER_PSP_SETTLEMENT : 52,
    PAYMENT_HELPER_PSP_SETTLEMENT_PARDAKHT_SHAKHSI : 53,
    PAYMENT_HELPER_PSP_SETTLEMENT_ONLINE_FACTOR : 54,
    PAYMENT_HELPER_PSP_SETTLEMENT_MONEY_REQUEST : 55,
    CARD_TO_CARD_RECHARGE_CREDIT : 56,
    CARD_TO_CARD_WALLET_RECHARGE : 57,
    ONLINE_CONTRACT_PRICE : 58,
};

export const transactionStr = {
    API: i18n.t('transaction.types.api'),
    PARDAKHT_SHAKHSI: i18n.t('transaction.types.face'),
    PAYMAN: i18n.t('transaction.types.payman'),
    IVR: i18n.t('transaction.types.ivr'),
    VIP: i18n.t('transaction.types.vip'),
    ALLOTMENT: i18n.t('transaction.types.allotment'),
    DEDICATED: i18n.t('transaction.types.dedicated'),
    ALLOTMENT_PAYMENT_HELPER: i18n.t('transaction.types.allotment'),
    ALLOTMENT_DEDICATED: i18n.t('transaction.types.allotment'),
    COLLECTIVE: i18n.t('transaction.types.collective'),
    COLLECTIVE_DEDICATED: i18n.t('transaction.types.collective_dedicated'),
    COLLECTIVE_PAYMENT_HELPER: i18n.t('transaction.types.collective_payment_helper'),
    CARD_TO_CARD: i18n.t('transaction.types.card_to_card'),
    SMS_WALLET_RECHARGE: i18n.t('transaction.types.sms_wallet_recharge'),
    MONEY_REQUEST: i18n.t('transaction.types.money_request'),
    OUT_SOURCE: i18n.t('transaction.types.out_source'),
    WALLET_RECHARGE: i18n.t('transaction.types.wallet_recharge'),
    COLLECTIVE_PARDAKHT_SHAKHSI: i18n.t('transaction.types.collective_pardakht_shakhsi'),
    COLLECTIVE_TO_WALLET_PARDAKHT_SHAKHSI: i18n.t('transaction.types.collective_to_wallet_pardakht_shakhsi'),
    COLLECTIVE_MONEY_REQUEST: i18n.t('transaction.types.collective_money_request'),
    COLLECTIVE_TO_WALLET_MONEY_REQUEST: i18n.t('transaction.types.collective_to_wallet_money_request'),
    MONEY_REQUEST_BILL: i18n.t('transaction.types.money_request_bill'),
    ONLINE_FACTOR: i18n.t('transaction.types.online_factor'),
    COLLECTIVE_TO_WALLET_ONLINE_FACTOR: i18n.t('transaction.types.collective_to_wallet_online_factor'),
    MONEY_REQUEST_BILL_TO_WALLET: i18n.t('transaction.types.money_request_bill_to_wallet'),
    IVR_WALLET_RECHARGE: i18n.t('transaction.types.ivr_wallet_recharge'),
    VIP_WALLET_RECHARGE: i18n.t('transaction.types.vip_wallet_recharge'),
    COLLECTIVE_TO_WALLET: i18n.t('transaction.types.collective_to_wallet'),
    ENAMAD_REGISTER: i18n.t('transaction.types.enamad_register'),
    OPEN_BANKING_WALLET_RECHARGE: i18n.t('transaction.types.open_banking_wallet_recharge'),

    COLLECTION_ON_PAYMENT_HELPER_TO_WALLET : i18n.t('transaction.types.collection_on_payment_helper_to_wallet'),
    COLLECTION_ON_PAYMENT_HELPER_TO_WALLET_MONEY_REQUEST : i18n.t('transaction.types.collection_on_payment_helper_to_wallet_money_request'),
    COLLECTION_ON_PAYMENT_HELPER_TO_WALLET_PARDAKHT_SHAKHSI : i18n.t('transaction.types.collection_on_payment_helper_to_wallet_pardakht_shakhsi'),
    COLLECTION_ON_PAYMENT_HELPER_TO_WALLET_ONLINE_FACTOR : i18n.t('transaction.types.collection_on_payment_helper_to_wallet_online_factor'),
    DEPOSIT_WITH_ID : i18n.t('transaction.types.deposit_with_id'),
    PAYMENT_HELPER_PSP_SETTLEMENT : i18n.t('transaction.types.payment_helper_psp_settlement'),
    PAYMENT_HELPER_PSP_SETTLEMENT_PARDAKHT_SHAKHSI : i18n.t('transaction.types.payment_helper_psp_settlement_pardakht_shakhsi'),
    PAYMENT_HELPER_PSP_SETTLEMENT_ONLINE_FACTOR : i18n.t('transaction.types.payment_helper_psp_settlement_online_factor'),
    PAYMENT_HELPER_PSP_SETTLEMENT_MONEY_REQUEST : i18n.t('transaction.types.payment_helper_psp_settlement_money_request'),
    CARD_TO_CARD_RECHARGE_CREDIT : i18n.t('transaction.types.card_to_card_recharge_credit'),
    CARD_TO_CARD_WALLET_RECHARGE : i18n.t('transaction.types.card_to_card_wallet_recharge'),
    ONLINE_CONTRACT_PRICE : i18n.t('transaction.types.online_contract_price'),

    get(type) {
        let transaction_str = null;
        Object.keys(transactionTypes).forEach(item => {
            if(transactionTypes[item] === type) {
                transaction_str = transactionStr[item]
            }
        });

        return transaction_str;
    },
};
